import React from 'react'

const DownArrow = () => (
  <svg width="13" height="9" viewBox="0 0 13 9" xmlns="http://www.w3.org/2000/svg"><path d="M12.5.503l-6 5.459L.503.5.5 3.035l6 5.465 6-5.465z" className="fill-current" fillRule="evenodd"/></svg>
)

export default DownArrow
